module.exports = __webpack_public_path__ + "static/media/hint_image_per_reservation.51242d5a.png";